import { showEntityDetailAction } from './showEntityDetail';
import { createEntityModalAction } from './createEntityModal';
import { COPILOT_DOMAINS } from '../constants';

// Import all actions here
const allActions = [showEntityDetailAction, createEntityModalAction];

// Build ACTION_DEFINITIONS organized by domain
export const ACTION_DEFINITIONS = allActions.reduce((acc, action) => {
    // For now, all actions go to SSM domain
    // You can add a 'domain' property to each action to customize this
    const domain = action.domain || COPILOT_DOMAINS.SSM;

    if (!acc[domain]) {
        acc[domain] = {};
    }

    acc[domain][action.key] = action.definition;
    return acc;
}, {});

// Export individual actions for direct use if needed
export { showEntityDetailAction, createEntityModalAction };
